import {  SlotGameType1_3 } from "../SlotGameType1_3";
// namespace SlotGames3
// {
	export class FireFruits3 extends SlotGameType1_3
	{
	}
// }